import styled from 'styled-components'

const FdpContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  width: 100%;
  box-sizing: border-box;
  max-width: 600px;
  margin: 0 auto;
`

const FdpLogo = styled.div`
  flex: none;
  width: 50%;
  box-sizing: border-box;
  padding: 10px 30px;
  text-align: center;
`

export { FdpContainer, FdpLogo }
